<template>
  <div>
    <v-toolbar class="toolbar-element" light absolute flat height="90em">
      <v-toolbar-title class="toolbar-title">Nuevo expediente</v-toolbar-title>
    </v-toolbar>
    <v-card class="spacing-top" v-if="loading">
      <v-flex offset-xs5 pa-5>
        <v-progress-circular :size="100" :width="5" color="primary" indeterminate></v-progress-circular>
      </v-flex>
    </v-card>
    <v-card class="spacing-top px-2 custom-font-regular" v-else>
      <v-card-text>
        <div class="title-form mt-3">Detalle</div>
        <v-divider class="mt-2 mb-3"></v-divider>
        <div class="mx-2">
          <v-layout row wrap>
            <v-flex xs6 pr-2>
              <v-text-field v-model="code" :error-messages="codeErrors" label="Número de expediente" required
                            @input="$v.code.$touch()" prepend-icon="fa-barcode"></v-text-field>
            </v-flex>
            <v-flex xs6 pl-2>
              <DatePickerForm v-model="date" label="Fecha de apertura"
                              :error-messages="dateErrors"></DatePickerForm>
            </v-flex>
            <v-flex xs6 pl-2>
              <v-autocomplete v-model="club" :items="clubs" label="Club principal" itemText="nombre" itemValue="pk"
                              prepend-icon="fa-users" light no-data-text="No hay datos disponibles" dense
                              :error-messages="clubErrors" :loading="loadingClubs"></v-autocomplete>
            </v-flex>
            <v-flex xs6 pl-2>
              <v-autocomplete v-model="thirdClub" :items="clubs" label="Club secundario (opcional)" itemText="nombre"
                              itemValue="pk" prepend-icon="fa-user-plus" light no-data-text="No hay datos disponibles"
                              dense clearable :loading="loadingClubs"></v-autocomplete>
            </v-flex>
            <v-flex xs4 pr-2>
              <v-text-field v-model="match" label="Partido (opcional)" prepend-icon="fa-futbol"></v-text-field>
            </v-flex>
            <v-flex xs4 px-2>
              <v-text-field v-model="matchStadium" label="Estadio (opcional)" prepend-icon="mdi-soccer-field"></v-text-field>
            </v-flex>
            <v-flex xs4 pl-2>
              <DatePickerForm v-model="matchDate" label="Fecha de partido (opcional)" clearable></DatePickerForm>
            </v-flex>
          </v-layout>
        </div>
        <div class="title-form mt-5">Hechos</div>
        <v-divider class="mt-2 mb-3"></v-divider>
        <div class="mx-2">
          <v-textarea v-model="act" :error-messages="actErrors" label="Hecho 1" required
                        @input="$v.act.$touch()"></v-textarea>
          <v-textarea v-for="(item, index) in acts" :key="'act'+index" v-model="acts[index]"
                        :label="`Hecho ${index + 2}`"></v-textarea>
          <v-tooltip bottom v-if="acts.length" class="mr-1">
            <v-btn color="grey" depressed class="square-button" slot="activator" @click="remove(acts)">
              <v-icon color="grey darken-3">remove</v-icon>
            </v-btn>
            <span>Borrar hecho</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn color="grey" depressed class="square-button" slot="activator" @click="add(acts)">
              <v-icon color="grey darken-3">add</v-icon>
            </v-btn>
            <span>Agregar hecho</span>
          </v-tooltip>
        </div>
        <div class="title-form mt-5">Posibles incumplimientos</div>
        <v-divider class="mt-2 mb-3"></v-divider>
        <div class="mx-2">
          <v-textarea v-model="infringement" :error-messages="infringementErrors" label="Artículo incumplido 1"
                        required @input="$v.infringement.$touch()"></v-textarea>
          <v-textarea v-for="(item, index) in infringements" :key="'infringements'+index"
                        v-model="infringements[index]" :label="`Artículo incumplido ${index + 2}`"></v-textarea>
          <v-tooltip bottom v-if="infringements.length" class="mr-1">
            <v-btn color="grey" depressed class="square-button" slot="activator" @click="remove(infringements)">
              <v-icon color="grey darken-3">remove</v-icon>
            </v-btn>
            <span>Borrar infracción</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn color="grey" depressed class="square-button" slot="activator" @click="add(infringements)">
              <v-icon color="grey darken-3">add</v-icon>
            </v-btn>
            <span>Agregar infracción</span>
          </v-tooltip>
        </div>
        <div class="title-form mt-5">Plazo de descargo</div>
        <v-divider class="mt-2 mb-3"></v-divider>
        <v-layout row wrap>
          <v-flex xs6 pr-2><DatePickerForm v-model="termDate" :error-messages="termDateErrors"></DatePickerForm></v-flex>
          <v-flex xs6 pl-2><TimePickerForm v-model="termTime" :error-messages="termTimeErrors"></TimePickerForm></v-flex>
        </v-layout>
        <div class="title-form mt-5">Archivos adjuntos asociados</div>
        <v-divider class="mt-2 mb-3"></v-divider>
        <div class="mx-2" v-if="uploadedFiles.length">
          <v-data-table :items="uploadedFiles" hide-actions hide-headers no-data-text="No hay datos disponibles">
            <template slot="items" slot-scope="props">
              <td><a :href="props.item.url" target="_blank">{{ props.item.name }}</a></td>
              <td class="text-xs-left">{{ props.item.description }}</td>
            </template>
          </v-data-table>
        </div>
        <div class="mx-2">
          <AttachFile ref="fileInput" @upload="uploadFiles" description></AttachFile>
          <v-checkbox v-if="files.length || uploadedFiles.length" v-model="canViewAttachments" label="Club puede ver adjuntos"></v-checkbox>
          <v-tooltip bottom>
            <v-btn color="grey" depressed class="square-button" slot="activator" @click="openFileDirectory">
              <v-icon color="grey darken-3">add</v-icon>
            </v-btn>
            <span>Agregar adjunto</span>
          </v-tooltip>
        </div>
        <v-divider class="mt-5 mb-2"></v-divider>
        <ConfirmationDialog :function-yes="bindingFunction" ref="confirm" title="Abandonar página"
                            text="Se perderán los cambios del formulario actual, ¿desea continuar?"></ConfirmationDialog>
        <v-card-actions>
          <v-btn color="grey" depressed :disabled="saving" @click="goBackConfirmation">Volver</v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="uploadAllFiles" depressed color="primary" :disabled="saving">Enviar</v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import { createEntityMixin } from '../../../mixins/createEntityMixin'
import { s3UploadMixin } from '../../../mixins/s3UploadMixin'
import DatePickerForm from '../../../common/ui/DatePickerForm'
import TimePickerForm from '../../../common/ui/TimePickerForm'
import AttachFile from '../../../common/ui/AttachFile'
import ConfirmationDialog from '../../../common/ui/ConfirmationDialog'

export default {
  mixins: [validationMixin, createEntityMixin, s3UploadMixin],

  validations () {
    return {
      code: { required },
      date: { required },
      club: { required },
      act: { required },
      infringement: { required },
      termDate: { required },
      termTime: { required }
    }
  },

  components: {
    DatePickerForm,
    TimePickerForm,
    AttachFile,
    ConfirmationDialog
  },

  data () {
    return {
      loadingClubs: false,
      code: '',
      date: null,
      clubs: [],
      club: null,
      thirdClub: null,
      match: '',
      matchDate: null,
      matchStadium: '',
      act: '',
      acts: [],
      infringement: '',
      infringements: [],
      termDate: null,
      termTime: null,
      canViewAttachments: false,
      uploadedFiles: [],
      createPath: 'case_file/new',
      editPath: `case_file/edit/${this.$route.params.idCaseFile}`
    }
  },

  computed: {
    isEditing () {
      return this.$route.params.hasOwnProperty('idCaseFile')
    },
    codeErrors () {
      return this.getRequiredErrors('code')
    },
    dateErrors () {
      return this.getRequiredErrors('date')
    },
    clubErrors () {
      return this.getRequiredErrors('club')
    },
    actErrors () {
      return this.getRequiredErrors('act')
    },
    infringementErrors () {
      return this.getRequiredErrors('infringement')
    },
    termDateErrors () {
      return this.getRequiredErrors('termDate')
    },
    termTimeErrors () {
      return this.getRequiredErrors('termTime')
    }
  },

  methods: {
    getPayload () {
      let payload = {
        'code': this.code,
        'date': this.date,
        'club': this.club,
        'third_club': this.thirdClub,
        'acts': [...[this.act], ...this.acts],
        'infringements': [...[this.infringement], ...this.infringements],
        'term': `${this.termDate} ${this.termTime}`,
        'can_view_attachments': this.canViewAttachments,
        'assets': this.assets
      }
      if (this.match) payload.match = this.match
      if (this.matchDate) payload.match_date = this.matchDate
      if (this.matchStadium) payload.match_stadium = this.matchStadium
      return payload
    },
    isValidForm () {
      return !this.$v.$invalid
    },
    fetchClubs () {
      this.loadingClubs = true
      this.axios
        .get('clubes')
        .then(response => {
          this.clubs = response.data
          this.loadingClubs = false
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    setCaseFileData (data) {
      this.code = data.code
      this.date = this.formatDateFromAPI(data.date)
      this.club = data.club.pk
      this.thirdClub = (data.thirdClub) ? data.thirdClub.pk : data.third_club
      this.match = data.match
      this.matchDate = this.formatDateFromAPI(data.matchDate)
      this.matchStadium = data.matchStadium
    },
    setOpeningEntryData (data) {
      this.act = data.detail.acts[0]
      this.acts = data.detail.acts.slice(1)
      this.infringement = data.detail.infringements[0]
      this.infringements = data.detail.infringements.slice(1)
      const [termDate, termTime] = data.detail.term.split(' ')
      this.termDate = this.formatDateFromAPI(termDate)
      this.termTime = termTime
      this.canViewAttachments = data.detail.canViewAttachments
      this.uploadedFiles = data.detail.assets
    },
    fetchData () {
      this.loading = true
      this.axios
        .get(`case_file/${this.$route.params.idCaseFile}`)
        .then(response => {
          this.setCaseFileData(response.data)
          this.axios
            .get(`case_file/entry/${response.data.entries[0].id}`)
            .then(entryResponse => {
              this.setOpeningEntryData(entryResponse.data)
              this.loading = false
            })
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    add (array) {
      array.push('')
    },
    remove (array) {
      array.pop()
    }
  },

  mounted () {
    this.fetchClubs()
  }
}
</script>

<style scoped>
.spacing-top {
  margin-top: 6em !important;
}
.title-form {
  font-size: 1.3em;
}
.square-button {
  margin: 0.5em 0 0 0;
  padding: 0 !important;
  width: 2em !important;
  height: 2em;
  min-width: 20px;
}
</style>
